export default __webpack_public_path__ + "static/media/burned.13c47269.svg";